/**
 * TanStack Query client (U6). All server state flows through this client;
 * zustand holds only session/theme/editor-buffer state (ARCHITECTURE.md).
 */
import { QueryClient } from '@tanstack/react-query';
import { ApiRequestError } from './http';
import { onSessionReset } from './session';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        // Client errors (4xx incl. auth/permission) are final — never retry.
        if (error instanceof ApiRequestError && error.statusCode < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});

onSessionReset(() => queryClient.clear());
